import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LogIn, KeyRound, Mail, Lock, X } from "lucide-react";
import { Toaster, toast } from "sonner";
import api, { readError } from "./api";
import { useAuth } from "./AuthContext";

export default function Login() {
  const { user, login, error, setError } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotBusy, setForgotBusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/setup/status");
        if (data.needs_setup) nav("/setup", { replace: true });
      } catch {}
    })();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (user && user.email) {
      const dest = loc.state?.from || "/";
      nav(dest, { replace: true });
    }
    // eslint-disable-next-line
  }, [user]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email.trim(), password);
    setBusy(false);
    if (ok) {
      toast.success("Hoş geldiniz");
      nav("/", { replace: true });
    }
  };

  const submitForgot = async (e) => {
    e.preventDefault();
    setForgotBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: forgotEmail.trim() });
      toast.success("Kayıtlıysa e-posta gönderildi");
      setForgot(false);
      setForgotEmail("");
    } catch (err) {
      toast.error(readError(err, "İşlem başarısız"));
    } finally {
      setForgotBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card" data-testid="login-card">
        <div className="login-brand">
          <div className="login-mark">CDS</div>
          <h1>Teklif Stüdyosu</h1>
          <p>Girmek için hesap bilgilerinizi kullanın</p>
        </div>
        <form onSubmit={submit} className="login-form">
          <label>
            <Mail size={14} /> E-posta
            <input data-testid="login-email" type="email" required
              value={email} onChange={e => { setError(""); setEmail(e.target.value); }}
              placeholder="ad@sirket.com" autoFocus />
          </label>
          <label>
            <Lock size={14} /> Şifre
            <input data-testid="login-password" type="password" required
              value={password} onChange={e => { setError(""); setPassword(e.target.value); }}
              placeholder="********" />
          </label>
          {error && <div className="login-error" data-testid="login-error">{error}</div>}
          <button data-testid="login-submit" className="primary-button login-submit" type="submit" disabled={busy}>
            <LogIn size={16} /> {busy ? "Giriş yapılıyor..." : "Giriş yap"}
          </button>
          <button type="button" data-testid="forgot-open" className="link-button" onClick={() => setForgot(true)}>
            <KeyRound size={13} /> Şifremi unuttum
          </button>
        </form>
      </div>

      {forgot && (
        <div className="modal-overlay" onClick={() => setForgot(false)}>
          <div className="modal-card" onClick={e => e.stopPropagation()} data-testid="forgot-modal">
            <button className="modal-close" onClick={() => setForgot(false)}><X size={16} /></button>
            <h2>Şifre sıfırlama</h2>
            <p>E-postanızı girin, kayıtlıysa sıfırlama bağlantısını göndeririz.</p>
            <form onSubmit={submitForgot} className="forgot-form">
              <input data-testid="forgot-email" type="email" required
                value={forgotEmail} onChange={e => setForgotEmail(e.target.value)}
                placeholder="ad@sirket.com" />
              <button data-testid="forgot-submit" className="primary-button" type="submit" disabled={forgotBusy}>
                <Mail size={14} /> {forgotBusy ? "Gönderiliyor..." : "Bağlantıyı gönder"}
              </button>
            </form>
          </div>
        </div>
      )}
      <Toaster position="bottom-right" />
    </div>
  );
}
